'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupBackInStockButtons = exports.init = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _wishlist = require('../services/wishlist');

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var WishlistBackInStockButton = function () {
  function WishlistBackInStockButton(el) {
    (0, _classCallCheck3.default)(this, WishlistBackInStockButton);

    this.el = el;
    this.config = this.getConfig();

    this.init();
  }

  (0, _createClass3.default)(WishlistBackInStockButton, [{
    key: 'init',
    value: function init() {
      this.el.dataset.backInStockButtonInit = true;
      this.setupListeners();
    }
  }, {
    key: 'setupListeners',
    value: function setupListeners() {
      var _this = this;
      this.el.addEventListener('click', function (e) {
        e.preventDefault();
        (0, _wishlist.addToWatchList)(_this.config, e);
      });
    }
  }, {
    key: 'getConfig',
    value: function getConfig() {
      var _el$dataset = this.el.dataset,
          title = _el$dataset.title,
          variantId = _el$dataset.variantId,
          id = _el$dataset.id,
          handle = _el$dataset.handle,
          featuredImage = _el$dataset.featuredImage,
          price = _el$dataset.price,
          addedClass = _el$dataset.addedClass,
          removedClass = _el$dataset.removedClass;

      return {
        title: title,
        variantId: parseInt(variantId),
        id: parseInt(id),
        handle: handle,
        featuredImage: featuredImage,
        price: price,
        addedClass: addedClass,
        removedClass: removedClass
      };
    }
  }]);
  return WishlistBackInStockButton;
}();

var init = exports.init = function init(_ref) {
  var el = _ref.el;
  return new WishlistBackInStockButton(el);
};

var setupBackInStockButtons = exports.setupBackInStockButtons = function setupBackInStockButtons() {
  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  (0, _functional.getElements)('[data-module="backinstock-button"', { context: context }).filter(function (el) {
    return !el.dataset.backInStockButtonInit;
  }).forEach(function (el) {
    return new WishlistBackInStockButton(el);
  });
};